<template>
  <div>
    <div v-if="this.newParticipation" class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Participations et résultats – compétition Poomsae</h3>
            <button type="button"
                    class="btn btn-xs btn-default btn-flat margin pull-right"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="resetParticipationForm()"
            >
              Réinitialiser le formulaire
            </button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group"
                     :class="{'has-error': errors.has('newParticipation[membre]') }">
                  <label for="searchmember">Compétiteur</label>
                  <v-select v-model="newParticipation.membre"
                            label="fullName"
                            :filterable="false"
                            :taggable="false"
                            :debounce="250"
                            :on-search="SearchMembersResponse"
                            :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link
                                                  :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                {{ props.selectedOption.fullName }}  - {{ props.selectedOption.age }}
                                                </router-link>
                                            </span>
                    <template slot="option" slot-scope="props">
                                            <span :class="props.item.licencie ? 'text-green' : 'text-red'">
                                                {{ props.item.fullName }} - {{ props.item.club.club }}
                                            </span>
                    </template>
                  </v-select>
                </div>

                <div class="form-group">
                  <label for="statut">Sexe</label>
                  <select id="statut" :disabled="!newParticipation.membre" class="form-control"
                          name="newParticipation[sexe]" v-model="sexeSelected">
                    <option :value="1"> Masculin</option>
                    <option :value="0"> Féminin</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="categage">Catégorie d'âge</label>
                  <select :disabled="!newParticipation.membre" id="categage" class="form-control"
                          name="newParticipation[categ_age]" v-model="newParticipation.id_age">
                    <option v-for="categ_age in getCategAgePoomsae"
                            :value="categ_age.id">
                      {{ categ_age.categ_age }} ({{ categ_age.age_min }} - {{ categ_age.age_max }} ans)
                    </option>
                  </select>
                </div>


                <div class="form-group">
                  <label for="categgrade">Catégorie de grade</label>
                  <select :disabled="!newParticipation.membre" id="categgrade" class="form-control"
                          name="newParticipation[categ_grade]" v-model="newParticipation.id_grade">
                    <!-- <option value="-1"></option> -->
                    <option v-for="cat_grade in getCategGradePoomsae"
                            :value="cat_grade.id"
                    >
                      {{ cat_grade.categ_grade }}
                    </option>
                  </select>
      
                </div>

                <div class="form-group">
                  <div class="checkbox">
                    <label for="teamABFT">
                      <input id="teamABFT" name="newParticipation[teamABFT]" type="checkbox"
                             v-model="newParticipation.teamABFT">
                      A participé sous la team ABFT ?
                    </label>
                  </div>
                </div>

              </div>

              <div class="col-md-6 col-md-push-2">
                <div class="form-group">
                  <label style="float:left;display: block;clear: both;" for="place">Place</label>
                  <div style="float:left;margin-left:30px;display: block;;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="place"
                           v-for="place in [1,2,3,4,5]">
                        <label>
                          <input v-html="get_place(place)"
                                 type="radio" name="newParticipation[place]" :id="place" :value="place"
                                 v-model="newParticipation.place">
                          <span v-html="get_place(place)"></span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="checkbox">
                        <label for="otherPlaceSelected">
                          <input id="otherPlaceSelected" name="newParticipation[otherPlaceSelected]" type="checkbox"
                                 v-model="otherPlaceSelected">
                          Autre place ?
                          <br/>
                          <input v-if="otherPlaceSelected" class="form-control" type="text" v-model="newParticipation.place" value=""/>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div style="float:left;margin-left:30px;display: block;;" class="">
                    <div class="form-group">
                      <div class="radio"
                           :for="place"
                           v-for="place in [6,7,8,9]">
                        <label>
                          <input v-html="get_place(place)"
                                 type="radio" name="newParticipation[place]" :id="place" :value="place"
                                 v-model="newParticipation.place">
                          <span v-html="get_place(place)"></span>
                        </label>
                      </div>
                    </div>
 

                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="overlay" v-if="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          <div class="box-footer">
            <input type="submit"
                   @click.prevent="addParticipation()"
                   :disabled="!isFormValid()"
                   value="Ajouter"
                   class="btn btn-primary pull-right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <b-col md="9" class="my-1">
              <h3 class="box-title">Listing des participations Poomsae: {{ getCompetitionPoomsae.participations.length }}
                résultat{{ getCompetitionPoomsae.participations.length > 1 ? 's' : '' }}</h3>
            </b-col>
            <b-col md="3" class="my-1">
              <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
            </b-col>
          </div>
          <div class="box-body">
            <b-table
              id="tableListingAllCompetitions"
              v-if="getCompetitionPoomsae!=null"
              responsive bordered striped hover
              :items="getCompetitionPoomsae.participations"
              :fields="columnsListingParticipations"
              :current-page="pagination_meta.current_page"
              :per-page="pagination_meta.per_page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :no-local-sorting="false"
              :no-sort-reset="true"
              :empty-text="'Aucun résultat'"
              :empty-filtered-text="'Aucun résultat'"
              :filter="filter"
              :busy.sync="loading"
              :sort-compare="sortCompareAdvanced"
              foot-clone
              show-empty
            >
              <template slot="actions" slot-scope="data">
                <button v-if="!isEditing(data.item.id)"
                        @click.prevent="editItem(data.item)"
                        class="btn btn-default padding2">
                  <i class="glyphicon glyphicon-pencil"></i>
                </button>
                <button v-if="!isEditing(data.item.id)"
                        @click.prevent="removeParticipations(data.item.id)"
                        class="btn btn-default padding2">
                  <i class="glyphicon glyphicon-remove"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="validEditing(data.item.id)"
                        class="btn btn-primary padding2">
                  <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="cancelEditing(data.item.id)"
                        class="btn btn-danger padding2">
                  <i class="glyphicon glyphicon-ban-circle"></i>
                </button>
              </template>

              <template slot="membre.nom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{ data.item.membre.nom }}
                </router-link>
              </template>

              <template slot="membre.prenom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{ data.item.membre.prenom }}
                </router-link>
              </template>

              <template slot="cat_sexe" slot-scope="data">
                {{ data.item.membre.sexe == 1 ? 'Masculin' : 'Féminin' }}
              </template>

              <template slot="cat_age" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ findCategAge(data.item.id_age).categ_age }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_age">
                    <option v-for="categ_age in getCategAgePoomsae"
                            :value="categ_age.id"
                    >
                      {{ categ_age.categ_age }} ({{ categ_age.age_min }} - {{ categ_age.age_max }} ans)
                    </option>
                  </select>
                </div>
              </template>

              <template slot="id_club" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  <span v-if="findClubById(data.item.id_club)">{{ findClubById(data.item.id_club).nameFormat }}</span>
                  <span v-if="!findClubById(data.item.id_club)" class="text-red">AUCUN</span>
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_club">
                    <option value="0">AUCUN</option>
                    <option v-for="club in getListeClub"
                            :value="club.id"
                    >
                      {{ club.nameFormat }}
                    </option>
                  </select>
                </div>
              </template>


              <template slot="cat_grade" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ findCategGrade(data.item.id_grade).categ_grade }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).id_grade">
                    <option v-for="cat_grade in getCategGradePoomsae"
                            :value="cat_grade.id"
                    >
                      {{ cat_grade.categ_grade }}
                    </option>
                  </select>
                </div>
              </template>

              <template slot="place" slot-scope="data">
                <div v-if="!isEditing(data.item.id)"
                     v-html="get_place(data.item.place)"></div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).place">
                    <option v-for="place in [1,2,3,4,5,9,17,33,65]"
                            :value="place"
                            v-html="get_place(place)"
                    ></option>
                  </select>
                </div>
              </template>


              <template slot="teamABFT" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value ? "OUI" : "NON" }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).teamABFT">
                    <option value="1">OUI</option>
                    <option value="0">NON</option>
                  </select>
                </div>
              </template>

              <template slot="afficherAuRanking" slot-scope="data">
                <div v-if="!isEditing(data.item.id)">
                  {{ data.value ? "OUI" : "NON" }}
                </div>
                <div v-if="isEditing(data.item.id)">
                  <select v-model="getObjectEditable(data.item.id).afficherAuRanking">
                    <option value="1">OUI</option>
                    <option value="0">NON</option>
                  </select>
                </div>
              </template>

              <template slot="pointsBonus" slot-scope="data">
                {{ data.value }}
              </template>

            </b-table>
            <b-pagination size="md"
                          :total-rows="getCompetitionPoomsae.participations.length"
                          v-model="pagination_meta.current_page"
                          :per-page="pagination_meta.per_page">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'
import ListSelectClub from '../../Communs/listeSelectClub'

require('bootstrap-datepicker/js/bootstrap-datepicker')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

var _ = require('underscore')
var moment = require('moment')

export default {
  props: {},
  data() {
    return {
      arrayEdits: [],
      arrayParticipationsEdits: [],
      arrayOriginal: [],
      sortBy: "membre.nom",
      sortDesc: null,
      filter: null,
      dejaParticipeAB: false,
      participations: null,
      listingCompetitions: [],
      loadingListingCompetition: true,
      loading: false,
      isBusy: false,
      disabledBtn: false,
      current_page: 1,
      periodeDu: null,
      periodeAu: null,
      typeSelectedForFilter: 0,
      reset: false,
      otherPlaceSelected: false,
      sexeSelected: 1,
      newParticipation: null,
      previousParticipation: null,
      previousRequest: false,
      ArrayMembersSearch: [],
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 20,
        to: 1,
        total: 1
      },
      columnsListingParticipations: [
        {
          label: 'Nom',
          key: 'membre.nom',
          sortable: true,
        },
        {
          label: 'Prénom',
          key: 'membre.prenom',
          sortable: true,
        },
        {
          label: 'A participé pour le club',
          key: 'id_club',
          sortable: true,
        },
        {
          label: 'Cat. Genre',
          key: 'cat_sexe',
          sortable: false,
        },
        {
          label: 'Cat. Age',
          key: 'cat_age',
          sortable: false,
        },
        {
          label: 'Cat. Grade',
          key: 'cat_grade',
          sortable: false,
        },
    
        {
          label: 'Place',
          key: 'place',
          sortable: true,
        },

        {
          label: 'Team ABFT ?',
          key: 'teamABFT',
          sortable: true,
        },
        {
          label: 'Afficher au ranking',
          key: 'afficherAuRanking',
          sortable: true,
        },
        {
          label: 'Points obtenus',
          key: 'pointsBonus',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getCompetitionPoomsae: 'getCompetitionPoomsae',
      getNiveauxCompetitionPoomsae: 'getNiveauxCompetitionPoomsae',
      getCategAgePoomsae: 'getCategAgePoomsae',
      getCategGradePoomsae: 'getCategGradePoomsae',
      getListeClub: 'getListeClub',
    }),
  },
  mounted: function () {
    var these = this
    this.resetParticipationForm()
    // this.getTableListingCompetition();
    this.$nextTick(function () {
      this.loadListeClub()
    })
  },
  created() {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm.getTableListingCompetition();
      // vm.loadStatutsCompetitions()
    })
  },
  watch: {
    'newParticipation.membre': function (membreSelectionne) {
      if (!membreSelectionne)
        return;
      this.sexeSelected = membreSelectionne.sexe;
      this.newParticipation.id_club = membreSelectionne.club.id
    },
  },
  components: {
    vSelect,
    ListSelectClub,
  },
  methods: {
    ...mapActions({
      setListeClub: 'setListeClub',
    }),
    findClubById: function (id) {
      return this.getListeClub.find((item) => {
        return item.id == id
      })
    },
    loadListeClub: function () {
      return this.$http.get(this.getRoute('getAllClubs')).then((response) => {
        this.setListeClub(response.body)
        // this.isLoaded.club = true
      }, (response) => {
        // this.isLoaded.club = false
      });
    },
    isFormValid: function () {
      return this.newParticipation.membre != null
        && this.newParticipation.id_age != null
        && this.newParticipation.id_club != null
        && this.newParticipation.id_grade != null
        && this.newParticipation.id_compet != null
        && this.newParticipation.id_compet != 0
        && this.newParticipation.id_grade != -1
        && this.newParticipation.id_age != -1
        && this.newParticipation.place != -1
    },
    resetParticipationForm: function () {
      this.sexeSelected = 1;
      if (this.newParticipation) {
        this.previousParticipation = {
          id_club: this.newParticipation.id_club,
          id_compet: this.newParticipation.id_compet,
          id_age: this.newParticipation.id_age,
          id_grade: this.newParticipation.id_grade,
          place: this.newParticipation.place,
          teamABFT: this.newParticipation.teamABFT,
          afficherAuRanking: this.newParticipation.afficherAuRanking,
        }
      }
      this.newParticipation = {
        membre: null,
        id_club: null,
        id_compet: this.getCompetitionPoomsae.id,
        id_age: null,
        id_grade: null,
        place: -1,
        teamABFT: false,
        afficherAuRanking: true,
      }
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      let these = this;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search}, {
        before(request) {
          if (these.previousRequest)
            these.previousRequest.abort();
          these.previousRequest = request;
        }
      }).then(resp => {
        loading(false)
        let idsAlreadyExists = "";
        this.ArrayMembersSearch = resp.data;
        this.getCompetitionPoomsae.participations.forEach((item) => {
          this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
            return item.membre.id == item2.id
          });
        })
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },
    constructForm: function () {
      return {
        id_membre: this.newParticipation.membre.id,
        id_club: this.newParticipation.id_club,
        id_compet: this.newParticipation.id_compet,
        id_age: this.newParticipation.id_age,
        id_grade: this.newParticipation.id_grade,
        place: this.newParticipation.place,
        teamABFT: this.newParticipation.teamABFT,
        afficherAuRanking: this.newParticipation.afficherAuRanking,
      }
    },
    constructFormParticipationsUpdate: function (participation) {
      return {
        id: participation.id,
        id_club: participation.id_club,
        id_compet: participation.id_compet,
        id_age: participation.id_age,
        id_grade: participation.id_grade,
        place: participation.place,
        teamABFT: participation.teamABFT,
        afficherAuRanking: participation.afficherAuRanking,
      }
    },
    addParticipation: function () {
      this.disabledBtn = true;
      this.loading = true
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competitionPoomsae.storeInscription'), this.constructForm()).then(function (response) {
        self.$noty.success(this.newParticipation.membre.fullName + " a été ajouté à la competition")
        this.disabledBtn = false
        this.getCompetitionPoomsae.participations = response.body
        this.loading = false
        this.resetParticipationForm();
        this.ArrayMembersSearch = []
      }, (response) => {
        self.$noty.error("Erreur dans l'ajout du membre")
        this.disabledBtn = false
        this.loading = false
      });
    },
    validEditing: function (id) {
      this.loading = true
      let participationsToUpdate = _.find(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      });
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competitionPoomsae.updateInscription'),
        this.constructFormParticipationsUpdate(participationsToUpdate)).then(function (response) {
        self.$noty.success("La participation a bien été modifiée.")
        this.disabledBtn = false
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
        this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
          return item.id == id;
        });

        let participationsToUpdateInTable = _.find(this.getCompetitionPoomsae.participations, function (item) {
          return item.id == id;
        });

        _.each(response.body, (item, index) => {
          participationsToUpdateInTable[index] = item;
        })
        this.loading = false
      }, (response) => {
        self.$noty.error("Erreur dans la modification de la participation")
        this.disabledBtn = false
        this.loading = false
      });
    },
    removeParticipations: function (id) {
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competitionPoomsae.deleteInscription'), {id: id}).then(function (response) {
        self.$noty.success("La participation a bien été supprimée")
        this.disabledBtn = false
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
        this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
          return item.id == id;
        });
        this.getCompetitionPoomsae.participations = _.reject(this.getCompetitionPoomsae.participations, function (item) {
          return item.id == id;
        });
      }, (response) => {
        self.$noty.error("Erreur dans la modification de la participation")
        this.disabledBtn = false
      });
    },
    flatten: function (obj) {
      var root = {};
      (function tree(obj, index) {
        var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          root[index + key + suffix] = obj[key];
          if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
          if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
      })(obj, "");
      return root;
    },
    sortCompareAdvanced: function (a, b, key) {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // Stringify the field data and use String.localeCompare
        return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
          numeric: true
        })
      }
    },
    getLabelFromKey: function (key) {
      switch (key) {
        case 'noire':
          return 'Dan';
          break;

        default:
          return key.charAt(0).toUpperCase() + key.slice(1);
          break;
      }
    },
    currentYear: function () {
      return moment().year();
    },
    console: function (event) {
      console.log(event);
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    get_place: function (numero) {
      switch (numero) {
        case 1:
          return "1<sup>er</sup>";
          break;
        default :
          return numero + "<sup>ème</sup>";
          break;
      }
    },

    findCategAge: function (id) {
      return _.find(this.getCategAgePoomsae, function (item) {
        return item.id == id;
      })
    },
    findCategGrade: function (id) {
      return _.find(this.getCategGradePoomsae, function (item) {
        return item.id == id;
      })
    },
    filterCategAgeForThisCompetition: function () {
      return this.getCategAgePoomsae
    },

    cancelEditing: function (id) {
      this.arrayEdits = _.reject(this.arrayEdits, function (item) {
        return item == id;
      });
      this.arrayParticipationsEdits = _.reject(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      });

    },
    getObjectEditable: function (id) {
      return _.find(this.arrayParticipationsEdits, function (item) {
        return item.id == id;
      })
    },
    editItem: function (item) {
      this.arrayEdits.push(item.id);
      this.arrayParticipationsEdits.push(item)
    },
    isEditing: function (id) {
      return _.contains(this.arrayEdits, id)
    },
  }
  ,
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  }
  ,
}
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/CompetitionPoomsae/InscriptionsResultatsPoomsae.vue